<template style="position:relative">
  <div>
    <div
      v-if="data.length === 0"
      class="notfound"
    >
      {{ text }}
    </div>
    <div>
      <VueApexCharts
        id="chart"
        :ref=s
        :name="name"
      ></VueApexCharts>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-mixed-operators */
/* eslint-disable no-restricted-syntax */
/* eslint-disable max-len */
/* eslint-disable no-undef */
import numberFormat from '@/libs/numberFormat';
import {
  Vue,
} from 'vue-property-decorator';
import VueApexCharts from 'vue-apexcharts';

Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    label: {
      type: Array,
      required: true,
    },
    s: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      required: true,
    },
    name: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      chart: null,
      text: '',

    };
  },

  watch: {
    value() {
      this.text = 'No Transaction';
    },

    chart() {
      this.chart.render();
    },

    data() {
      if (this.chart !== null) {
        this.chart.destroy();
      }
      if (this.s === 'amount') {
        const chart = new ApexCharts(this.$refs[this.s], {
          chart: {
            width: 560,
            type: 'donut',
            id: 'chart',
          },
          labels: this.label ? this.label : [],
          series: this.data ? this.data : [],

          dataLabels: {
            enabled: false,
            formatter(value, { seriesIndex, w }) {
              return `${value.toFixed(2)}% (${numberFormat(w.config.series[seriesIndex], true)}) `;
            },
            style: {
              fontSize: '12px',
              fontWeight: 'bold',
            },
            background: {
              enabled: true,
              foreColor: '#000',
              borderRadius: 2,
              padding: 4,
              opacity: 0.9,
              borderWidth: 1,
              borderColor: '#000',
              backgroundColor: 'red',
            },
            dropShadow: {
              enabled: false,
            },
          },
          plotOptions: {
            pie: {
              startAngle: 0,
              expandOnClick: true,
              offsetX: 0,
              offsetY: 0,
              customScale: 1,
              dataLabels: {
                offset: 10,
                minAngleToShowLabel: 0,
              },
            },
          },
          tooltip: {
            enabled: true,
            custom({
              series, seriesIndex, w,
            }) {
              let total = 0; for (const x of series) { total += x; } const selected = series[seriesIndex];
              return `<div style="padding:10px;background-color: ${w.config.colors[seriesIndex]};"> ${w.config.labels[seriesIndex]} <div> ${numberFormat(parseFloat(selected), true)} (${(parseFloat(selected) / total * 100).toFixed(2)}%)</div></div>`;
            },
          },
          legend: {
            show: true,
            formatter(seriesName, opts) {
              let total = 0; for (const x of opts.w.globals.series) { total += x; } const selected = opts.w.globals.series[opts.seriesIndex];
              return [seriesName, `</br>${numberFormat(selected, true)} (${(parseFloat(selected) / total * 100).toFixed(2)}%)`];
            },
            horizontalAlign: 'center',
            position: 'right',
            itemMargin: {
              horizontal: 5,
              vertical: 7,
            },
            markers: {
              width: 12,
              height: 12,
              strokeWidth: 0,
              strokeColor: '#fff',
              fillColors: undefined,
              radius: 2,
              customHTML: undefined,
              onClick: undefined,
              offsetX: 0,
              offsetY: 0,
            },
          },
          colors: ['#22A7F0', '#E05D6F', '#5BD173', '#FFCF07', '#01BAC1', '#B770E3', '#635BD1', '#EC9D14', '#14ECCF', '#EC14E5', '#E67F7F'],
          responsive: [{
            breakpoint: 1370,
            options: {
              chart: {
                width: 420,
              },
            },
          }],
        });

        this.chart = chart;
      } else {
        this.chart = new ApexCharts(this.$refs[this.s], {
          chart: {
            width: 560,
            type: 'donut',
            id: 'chart',
          },
          labels: this.label ? this.label : [],
          series: this.data ? this.data : [],

          dataLabels: {
            enabled: false,
            formatter(value, { seriesIndex, w }) {
              return `${value.toFixed(2)}% (${numberFormat(w.config.series[seriesIndex])}) `;
            },
            style: {
              fontSize: '12px',
              fontWeight: 'bold',
              textShadow: false,
            },
            background: {
              enabled: true,
              foreColor: '#000',
              borderRadius: 2,
              padding: 4,
              opacity: 0.9,
              borderWidth: 1,
              borderColor: '#000',
              backgroundColor: 'red',
            },
            dropShadow: {
              enabled: false,
            },
          },
          plotOptions: {
            pie: {
              startAngle: 0,
              expandOnClick: true,
              offsetX: 0,
              offsetY: 0,
              customScale: 1,
              dataLabels: {
                offset: 10,
                minAngleToShowLabel: 0,
              },
            },
          },
          tooltip: {
            enabled: true,
            custom({
              series, seriesIndex, w,
            }) {
              let total = 0; for (const x of series) { total += x; } const selected = series[seriesIndex];
              return `<div style="padding:10px;background-color: ${w.config.colors[seriesIndex]};"> ${w.config.labels[seriesIndex]} <div> ${numberFormat(parseFloat(selected))} (${(parseFloat(selected) / total * 100).toFixed(2)}%)</div></div>`;
            },
          },
          legend: {
            show: true,
            formatter(seriesName, opts) {
              let total = 0; for (const x of opts.w.globals.series) { total += x; } const selected = opts.w.globals.series[opts.seriesIndex];
              return [seriesName, `</br>${numberFormat(selected)} (${(parseFloat(selected) / total * 100).toFixed(2)}%)`];
            },
            horizontalAlign: 'center',
            position: 'right',
            itemMargin: {
              horizontal: 5,
              vertical: 7,
            },
            markers: {
              width: 12,
              height: 12,
              strokeWidth: 0,
              strokeColor: '#fff',
              fillColors: undefined,
              radius: 2,
              customHTML: undefined,
              onClick: undefined,
              offsetX: 0,
              offsetY: 0,
            },
          },
          colors: ['#22A7F0', '#E05D6F', '#5BD173', '#FFCF07', '#01BAC1', '#B770E3', '#635BD1', '#EC9D14', '#14ECCF', '#EC14E5', '#E67F7F'],
          responsive: [{
            breakpoint: 1370,
            options: {
              chart: {
                width: 420,
              },
            },
          }],
        });
      }
      // this.chart.render();
    },
  },
};
</script>

<style lang="scss" scoped>
.notfound {
  font-weight: bold;
  font-size: 13px;
  color: rgb(119, 119, 119);
  position: absolute;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
}
</style>
